import dayjs from 'dayjs';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { DateFormat } from '@/modules/core/app/constants/date.constants';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class Note extends BaseEntityModel {
  /**
   * @var {?number}
   */
  id;

  /**
   * @var {?string}
   */
  modelType;

  /**
   * @var {?number}
   */
  modelId;

  /**
   * @var {string}
   */
  text;

  /**
   * @var {boolean}
   */
  isPinned;

  /**
   * @var {number}
   */
  createdByUserId;

  /**
   * @relationship
   * @var {Asset}
   */
  asset;

  /**
   * @relationship
   * @var {Document}
   */
  document;

  /**
   * @relationship
   * @var {Liability}
   */
  liability;

  /**
   * @relationship
   * @var {User}
   */
  createdByUser;

  /**
   * @relationship
   * @var {User}
   */
  lastEditedByUser;

  /**
   * @var {string}
   */
  type;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.text = model.text;
    this.isPinned = model.isPinned;
    this.estateId = model.estateId;
    this.createdByUserId = model.createdByUserId;
    this.type = model.type;
  }

  /**
   * @returns {ModelType}
   */
  getModelName() {
    return ModelType.NOTE;
  }

  /**
   * @return {boolean}
   */
  get isEstateNote() {
    return this.modelType === null;
  }

  get formattedDate() {
    return dayjs(this.createdAt).format(DateFormat.FULL_MONTH_DAY_YEAR);
  }
}
